<template>
  <div class="home">

    <!--Top Bar-->
    <TopBar msg="Welcome to Your Vue.js App" />

    <!--Web View Start-->
    <div class="d-none d-md-block d-md-block d-lg-block d-xl-block d-xxl-block">

      <!--banner-->
      <template v-if="bannerList.length >= '2'">
        <v-carousel hide-delimiters height="auto" show-arrows="hover">
          <v-carousel-item v-for="(banner, i) in bannerList" :key="i" :src="banner.image" cover @click="bannerUrl(banner)"></v-carousel-item>
        </v-carousel>
      </template>
      <template v-else>
        <v-carousel hide-delimiters height="auto" :show-arrows="false">
          <v-carousel-item v-for="(banner, i) in bannerList" :key="i" :src="banner.image" cover @click="bannerUrl(banner)"></v-carousel-item>
        </v-carousel>
      </template>
      <!--banner-->

      <!--banner-->
      <!--<v-carousel hide-delimiters height="auto" show-arrows="hover">
        <v-carousel-item :src="sigmabanner1" cover></v-carousel-item>
        <v-carousel-item :src="sigmabanner1" cover></v-carousel-item>
      </v-carousel>-->
      <!--banner-->

      <v-row dense no-gutters>
        <v-col cols="12" sm="12" md="12">
          <v-card elevation="0" color="background" height="450">
            <div class="mt-15 web-title">
              Pure Goodness From Our Farm
            </div>
            <div class="d-flex justify-center mt-2">
              <v-sheet class="mx-auto bg-background" elevation="0" min-width="300">
                <v-slide-group>
                  <v-slide-group-item>
                    <v-card width="210" height="220" class="ma-6 rounded-xl bg-white" elevation="0" color="primary"
                      variant="outlined">
                      <v-avatar color="white" size="75" rounded="0" class="mt-15">
                        <v-img :src="group1"></v-img>
                      </v-avatar>
                      <p class="text-black web-text mt-6">Handpicked</p>
                    </v-card>
                  </v-slide-group-item>

                  <v-slide-group-item>
                    <v-card width="210" height="220" class="ma-6 rounded-xl bg-white" elevation="0" color="primary"
                      variant="outlined">
                      <v-avatar color="white" size="75" rounded="0" class="mt-15">
                        <v-img :src="group2"></v-img>
                      </v-avatar>
                      <p class="text-black web-text mt-6">Truly Fresh</p>
                    </v-card>
                  </v-slide-group-item>

                  <v-slide-group-item>
                    <v-card width="210" height="220" class="ma-6 rounded-xl bg-white" elevation="0" color="primary"
                      variant="outlined">
                      <v-avatar color="white" size="75" rounded="0" class="mt-15">
                        <v-img :src="group3"></v-img>
                      </v-avatar>
                      <p class="text-black web-text mt-6">Nutrient Dense</p>
                    </v-card>
                  </v-slide-group-item>

                  <v-slide-group-item>
                    <v-card width="210" height="220" class="ma-6 rounded-xl bg-white" elevation="0" color="primary"
                      variant="outlined">
                      <v-avatar color="white" size="75" rounded="0" class="mt-15">
                        <v-img :src="group4"></v-img>
                      </v-avatar>
                      <p class="text-black web-text mt-6">Toxic-Free</p>
                    </v-card>
                  </v-slide-group-item>

                  <v-slide-group-item>
                    <v-card width="210" height="220" class="ma-5 rounded-xl bg-white" elevation="0" color="primary"
                      variant="outlined">
                      <v-avatar color="white" size="75" rounded="0" class="mt-15">
                        <v-img :src="group5"></v-img>
                      </v-avatar>
                      <p class="text-black web-text mt-6">Literally Tastier</p>
                    </v-card>
                  </v-slide-group-item>
                </v-slide-group>
              </v-sheet>
            </div>
          </v-card>
        </v-col>
      </v-row>

      <!--Products-->
      <v-row dense no-gutters>
        <v-col cols="12" sm="12" md="12">
          <v-card class="ma-4 mx-auto rounded-xl" elevation="0" color="white">
            <div class="cart-block">
              <v-col cols="12" sm="12" md="12">
                <div class="web-title">
                  Our Bestsellers
                </div>
              </v-col>
              <div class="d-flex justify-center mb-6 ">
                <v-sheet class="mx-auto" elevation="0" min-width="300" color="white">
                  <v-slide-group>
                    <v-slide-group-item v-for="product, index in highlightProductList" :key="product.id">
                      <v-card width="220" class="ma-4" elevation="0" color="#fff" min-height="410" max-height="410">

                        <v-card class="float-right mr-0 organic-card" color="primary" elevation="0">
                          <v-btn color="white" variant="plain" size="small" v-if="product.organic">
                            <v-icon color="white">mdi-leaf-circle</v-icon> &nbsp;Organic
                          </v-btn>
                        </v-card>

                        <div class="product-img-1 pa-5 rounded-xl" v-if="parseFloat(index + 1) % 2 == 1">
                          <v-img height="170" width="140" class="mx-auto mt-3" :src="product.image"></v-img>
                        </div>
                        <div class="product-img-2 pa-5 rounded-xl" v-else-if="parseFloat(index + 1) % 3 == 1">
                          <v-img height="170" width="140" class="mx-auto mt-3" :src="product.image"></v-img>
                        </div>
                        <div class="product-img-3 pa-5 rounded-xl" v-else-if="parseFloat(index + 1) % 4 == 1">
                          <v-img height="170" width="140" class="mx-auto mt-3" :src="product.image"></v-img>
                        </div>
                        <div class="product-img-4 pa-5 rounded-xl" v-else-if="parseFloat(index + 1) % 5 == 1">
                          <v-img height="170" width="140" class="mx-auto mt-3" :src="product.image"></v-img>
                        </div>

                        <div class="product-img-5 pa-5 rounded-xl" v-else>
                          <v-img height="170" width="140" class="mx-auto mt-3" :src="product.image"></v-img>
                        </div>

                        <v-card-item class="text-left bg-white" color="#fff">
                          <v-card-title class="text-black web-text text-center text-wrap" v-if="!product.description">
                            {{ product.name }}
                          </v-card-title>
                          <div class="text-center" v-if="product.description">
                            <v-menu location="end">
                              <template v-slot:activator="{ props }">
                                <!--<v-btn color="primary" dark v-bind="props">
                                  Dropdown
                                </v-btn>-->
                                <v-card-title class="text-black web-text text-center" v-bind="props">
                                  {{ product.name }} <v-icon color="black">mdi-chevron-right</v-icon>
                                </v-card-title>
                              </template>
                              <v-card min-width="280" max-width="280" rounded="lg">
                                <v-img :src="product.image" height="150" class="mx-auto mt-3">
                                </v-img>
                                <v-card-title class="text-black web-text text-center">
                                  {{ product.name }}
                                </v-card-title>
                                <v-divider class="ma-1"></v-divider>
                                <v-card-text class="ml-3">
                                  <div v-html="product.description"></div>
                                </v-card-text>
                              </v-card>
                            </v-menu>
                          </div>
                        </v-card-item>
                        <v-divider class="mx-4 mb-1"></v-divider>
                        <div class="px-1">
                          <v-chip-group v-model="product.unitSelected" selected-class="text-green-darken-4" mandatory>
                            <v-chip v-for="unit in product.unit" :key="unit.unit_id" :value="unit.unit_id"
                              @click="productUnitSelect(product, unit)">{{
                                unit.unit_name }}</v-chip>
                          </v-chip-group>
                        </div>
                        <v-card-actions class="justify-left product-card-actions">
                          <v-btn variant="text" min-width="75" min-height="30" class="text-center"
                            v-if="product.priceSelected">
                            <p class="text-primary price-text">Rs.
                              {{ product.priceSelected }}</p>
                          </v-btn>
                          <div v-if="locationDetails.sale == true">
                            
                            <template v-if="(product.unit).length != '0'">
                              <v-btn color="primary" rounded variant="flat" size="small" min-height="30" class="text-center"
                                @click="productAdd(product)" v-if="product.qty == 0">
                                <p class="text-white">ADD</p>
                              </v-btn>
                              <div v-if="product.qty > 0">
                                <v-btn size="24" variant="flat" color="primary" icon @click="decrement(product)">
                                  <v-icon color="white" size="14">mdi-minus</v-icon>
                                </v-btn>
                                <span class="text-black ml-2">
                                  <!-- {{ product.qty }} -->
                                  <input type="number" v-model="product.proqty" class="product-web-textbox" @keyup="productqty(product)" >
                                </span>
                                <v-btn size="24" variant="flat" color="primary" icon @click="increment(product)">
                                  <v-icon color="white" size="14">mdi-plus</v-icon>
                                </v-btn>
                              </div>
                            </template>
                            <template v-else>
                                <v-btn color="orange" rounded variant="tonal" size="small" min-width="70" min-height="30" class="text-center">
                                    <p class="text-black">Sold Out</p>
                                </v-btn>
                            </template>
                          </div>


                        </v-card-actions>
                      </v-card>
                    </v-slide-group-item>
                  </v-slide-group>
                </v-sheet>
              </div>
            </div>
          </v-card>
        </v-col>
      </v-row>
      <!--Products-->

      <!--branchstore-->
      <v-row dense no-gutters class="pa-5 bg-accent">
        <v-col cols="12" sm="12" md="12">
          <div class="web-title mt-7 mb-5">
            Our Brand Stores
          </div>
        </v-col>
        <v-col cols="12" sm="12" md="12" v-if="brandLists.length != '0'">
          <!--<div class="brand-line"></div>-->
          <div class="d-flex justify-center ml-15 mr-15 mb-10">
            <v-sheet class="mx-auto bg-white" rounded="xl" elevation="0" min-width="300" height="300">
              <v-slide-group>
                <v-slide-group-item v-for="brand in brandLists" :key="brand.id">
                  <v-card width="390" height="300" class="pa-15  justify-center" elevation="0" color="#fff"
                    @click="brandPage(brand.slug)">
                    <v-img class="mx-auto" width="250" height="230" :src="brand.logo"></v-img>
                  </v-card>
                  <!-- <v-divider vertical></v-divider> -->
                </v-slide-group-item>
              </v-slide-group>
            </v-sheet>
          </div>
        </v-col>
      </v-row>
      <!--branchstore-->

      <!--category-->
      <v-container>
        <v-row dense>
          <v-col cols="12" sm="12" md="12">
            <div class="mt-4 web-title">Explore our categories
            </div>
          </v-col>
          <v-col cols="12" sm="12" md="12" lg="12">
            <div class="d-flex justify-center">
              <v-sheet min-width="600" max-width="1500" class="d-sm-flex d-md-flex d-lg-flex flex-wrap bg-white">
                <v-sheet class="ma-3 bg-white" v-for="subCategory, index in subCategoryList" :key="subCategory.id"
                  style="cursor: pointer" width="250" height="280">
                  <div @click="categoryPage(subCategory.category_id, subCategory.id)" class="ma-3">
                    <div class="product-img-1 pa-5 rounded-xl" v-if="parseFloat(index + 1) % 2 == 1">
                      <v-img height="170" width="140" class="mx-auto mt-3" :src="subCategory.image"></v-img>
                      <p class="category-text">{{ subCategory.name }}</p>
                    </div>
                    <div class="product-img-2 pa-5 rounded-xl" v-else-if="parseFloat(index + 1) % 3 == 1">
                      <v-img height="170" width="140" class="mx-auto mt-3" :src="subCategory.image"></v-img>
                      <p class="category-text">{{ subCategory.name }}</p>
                    </div>
                    <div class="product-img-3 pa-5 rounded-xl" v-else-if="parseFloat(index + 1) % 4 == 1">
                      <v-img height="170" width="140" class="mx-auto mt-3" :src="subCategory.image"></v-img>
                      <p class="category-text">{{ subCategory.name }}</p>
                    </div>
                    <div class="product-img-4 pa-5 rounded-xl" v-else-if="parseFloat(index + 1) % 5 == 1">
                      <v-img height="170" width="140" class="mx-auto mt-3" :src="subCategory.image"></v-img>
                      <p class="category-text">{{ subCategory.name }}</p>
                    </div>
                    <div class="product-img-5 pa-5 rounded-xl" v-else>
                      <v-img height="170" width="140" class="mx-auto mt-3" :src="subCategory.image"></v-img>
                      <p class="category-text">{{ subCategory.name }}</p>
                    </div>
                  </div>
                </v-sheet>
              </v-sheet>
            </div>
          </v-col>
        </v-row>
      </v-container>
      <!--category End-->
    </div>
    <!--Web View End-->


    <!--Mobile View-->

    <div class="d-block d-md-none d-md-none d-lg-none d-xl-none d-xxl-none">

      <v-card class="rounded-xl justify-center bg-secondary mt-n6 mx-auto" elevation="0">

        <!--Mobile Banner-->
        <v-row dense no-gutters class="bg-secondary mt-7">
          <v-col cols="12" sm="12" md="12">
            <div class="d-flex justify-center">
              <v-sheet class="mx-auto bg-secondary" elevation="0" min-width="290">
                <v-slide-group>
                  <v-slide-group-item v-for="(banner, i) in bannerList" :key="i">
                    <v-card width="290" class="ma-5 rounded-xl justify-center" elevation="0" color="#fff">
                      <!--<v-img :src="banner.image" cover @click="bannerUrl(banner)"></v-img>-->
                      <div v-bind:style="{
                        backgroundImage: 'url(' + banner.image + ')', height: '140px', backgroundSize: 'cover'
                      }" @click="bannerUrl(banner)"></div>
                    </v-card>
                  </v-slide-group-item>
                </v-slide-group>
              </v-sheet>
            </div>
          </v-col>
        </v-row>
        <!--Mobile Banner-->

        <!--Mobile Content-->
        <v-container class="mobile-margin-top">
          <v-row dense no-gutters>
            <v-col cols="12" sm="12" md="12">
              <div class="d-flex justify-center mt-3">
                <v-sheet class="mx-auto bg-secondary" elevation="0">
                  <v-slide-group>

                    <v-slide-group-item>
                      <v-card color="secondary" elevation="0">
                        <v-card width="60" height="60" class="ma-2 rounded-lg bg-white" elevation="0" color="primary"
                          variant="outlined">
                          <v-avatar color="white" size="22" rounded="0" class="mt-4">
                            <v-img :src="group1"></v-img>
                          </v-avatar>
                        </v-card>
                        <p class="text-black mobile-text">Handpicked</p>
                      </v-card>
                    </v-slide-group-item>

                    <v-slide-group-item>
                      <v-card color="secondary" elevation="0">
                        <v-card width="60" height="60" class="ma-2 rounded-lg bg-white" elevation="0" color="primary"
                          variant="outlined">
                          <v-avatar color="white" size="22" rounded="0" class="mt-4">
                            <v-img :src="group2"></v-img>
                          </v-avatar>
                        </v-card>
                        <p class="text-black mobile-text">Truly Fresh</p>
                      </v-card>
                    </v-slide-group-item>

                    <v-slide-group-item>
                      <v-card color="secondary" elevation="0">
                        <v-card width="60" height="60" class="ma-2 rounded-lg bg-white" elevation="0" color="primary"
                          variant="outlined">
                          <v-avatar color="white" size="22" rounded="0" class="mt-4">
                            <v-img :src="group3"></v-img>
                          </v-avatar>
                        </v-card>
                        <p class="text-black mobile-text">Nutrient Dense</p>
                      </v-card>
                    </v-slide-group-item>

                    <v-slide-group-item>
                      <v-card color="secondary" elevation="0">
                        <v-card width="60" height="60" class="ma-2 rounded-lg bg-white" elevation="0" color="primary"
                          variant="outlined">
                          <v-avatar color="white" size="22" rounded="0" class="mt-4">
                            <v-img :src="group4"></v-img>
                          </v-avatar>
                        </v-card>
                        <p class="text-black mobile-text">Toxic-Free</p>
                      </v-card>
                    </v-slide-group-item>

                    <v-slide-group-item>
                      <v-card color="secondary" elevation="0">
                        <v-card width="60" height="60" class="ma-2 rounded-lg bg-white" elevation="0" color="primary"
                          variant="outlined">
                          <v-avatar color="white" size="22" rounded="0" class="mt-4">
                            <v-img :src="group5"></v-img>
                          </v-avatar>
                        </v-card>
                        <p class="text-black mobile-text">Literally Tastier</p>
                      </v-card>
                    </v-slide-group-item>
                  </v-slide-group>
                </v-sheet>
              </div>
            </v-col>
          </v-row>
        </v-container>
        <!--Mobile Content-->
      </v-card>
      <!--Products-->
      <!--Products-->
      <v-row dense no-gutters>
        <v-col cols="12" sm="12" md="12">
          <v-card class="ma-4 mx-auto rounded-xl" elevation="0" color="white">
            <div class="cart-block">
              <v-col cols="12" sm="12" md="12">
                <div class="mobile-title text-left ml-1">
                  Our Bestsellers
                </div>
              </v-col>
              <div class="d-flex justify-center">
                <v-sheet class="mx-auto" elevation="0" min-width="300" color="white">
                  <v-slide-group>
                    <v-slide-group-item v-for="product, index in highlightProductList" :key="product.id">
                      <v-card width="200" class="ma-4" elevation="0" color="#fff" min-height="320" max-height="320">
                        <v-card class="float-right mr-0 organic-card" color="primary" elevation="0">
                          <v-btn color="white" variant="plain" size="small" v-if="product.organic">
                            <v-icon color="white">mdi-leaf-circle</v-icon>&nbsp; Organic
                          </v-btn>
                        </v-card>
                        <div class="product-img-1 pa-8 rounded-xl" v-if="parseFloat(index + 1) % 2 == 1">
                          <v-img height="120" width="120" class="mx-auto" :src="product.image"></v-img>
                        </div>
                        <div class="product-img-2 pa-8 rounded-xl" v-else-if="parseFloat(index + 1) % 3 == 1">
                          <v-img height="120" width="120" class="mx-auto" :src="product.image"></v-img>
                        </div>
                        <div class="product-img-3 pa-8 rounded-xl" v-else-if="parseFloat(index + 1) % 4 == 1">
                          <v-img height="120" width="120" class="mx-auto" :src="product.image"></v-img>
                        </div>
                        <div class="product-img-4 pa-8 rounded-xl" v-else-if="parseFloat(index + 1) % 5 == 1">
                          <v-img height="120" width="120" class="mx-auto" :src="product.image"></v-img>
                        </div>

                        <div class="product-img-5 pa-8 rounded-xl" v-else>
                          <v-img height="120" width="120" class="mx-auto" :src="product.image"></v-img>
                        </div>

                        <v-card-item class="text-left bg-white" color="#fff">
                          <v-card-title class="text-black mobile-product-title text-center text-wrap"
                            v-if="!product.description">{{
                              product.name }}</v-card-title>
                          <div class="text-center" v-if="product.description">
                            <v-menu location="end">
                              <template v-slot:activator="{ props }">
                                <v-card-title class="text-black mobile-product-title text-center" v-bind="props">
                                  {{ product.name }}
                                  <v-icon color="black">mdi-chevron-right</v-icon></v-card-title>
                              </template>
                              <v-card min-width="250" max-width="250" rounded="lg">
                                <v-img :src="product.image" height="120" class="mx-auto mt-3">
                                </v-img>
                                <v-card-title class="text-black web-text text-center">
                                  {{ product.name }}
                                </v-card-title>
                                <v-divider class="ma-1"></v-divider>
                                <v-card-text class="ml-3">
                                  <div v-html="product.description"></div>
                                </v-card-text>
                              </v-card>
                            </v-menu>
                          </div>
                          <!-- <v-card-subtitle class="text-left" v-if="product.priceSelected">
                            <span class="text-black font-weight-black me-1">Rs. {{ product.priceSelected }}</span>
                          </v-card-subtitle>-->
                        </v-card-item>
                        <v-divider class="mx-4 mb-1"></v-divider>
                        <!--<v-card-title>Tonight's availability</v-card-title>-->
                        <div class="px-1">
                          <v-chip-group v-model="product.unitSelected" selected-class="text-green-darken-4" mandatory>
                            <v-chip v-for="unit in product.unit" :key="unit.unit_id" :value="unit.unit_id"
                              @click="productUnitSelect(product, unit)" class="best-mobile-chip-text">{{
                                unit.unit_name }}</v-chip>
                          </v-chip-group>
                        </div>
                        <v-card-actions class="justify-left product-card-actions">
                          <v-btn variant="text" min-width="75" min-height="30" class="text-center"
                            v-if="product.priceSelected">
                            <p class="text-primary price-text">Rs.
                              {{ product.priceSelected }}</p>
                          </v-btn>

                          <div v-if="locationDetails.sale == true">
                            <template v-if="(product.unit).length != '0'">
                              <v-btn color="primary" rounded variant="flat" size="small" min-height="30" class="text-center"
                                @click="productAdd(product)" v-if="product.qty == 0">
                                <p class="text-white">ADD</p>
                              </v-btn>
                              <div v-if="product.qty > 0">
                                <v-btn size="20" variant="flat" color="primary" icon @click="decrement(product)">
                                  <v-icon color="white" size="12">mdi-minus</v-icon>
                                </v-btn>
                                <span class="text-black cart-qty-text">
                                  <!-- {{ product.qty }} -->
                                  <input type="number" v-model="product.proqty" class="product-mobile-textbox" @keyup="productqty(product)" >
                                </span>
                                <v-btn size="20" variant="flat" color="primary" icon @click="increment(product)" class="product-mobile-buttonplus">
                                  <v-icon color="white" size="12">mdi-plus</v-icon>
                                </v-btn>
                              </div>
                            </template>
                            <template v-else>
                              <v-btn color="orange" rounded variant="tonal" size="small" min-width="70" min-height="30" class="text-center">
                                  <p class="text-black">Sold Out</p>
                              </v-btn>
                            </template>
                          </div>


                        </v-card-actions>
                      </v-card>
                    </v-slide-group-item>
                  </v-slide-group>
                </v-sheet>
              </div>
            </div>
          </v-card>
        </v-col>
      </v-row>
      <!--Products-->
      <!--Products End -->
      <!--category-->
      <v-container>
        <v-row dense>
          <v-col cols="12" sm="12" md="12">
            <div class="mobile-title text-left mt-n9">Explore our categories
            </div>
          </v-col>
          <v-col cols="12" sm="12" md="12" lg="12">
            <div class="d-flex justify-center">
              <v-sheet class="d-flex flex-wrap bg-white">
                <v-sheet class="bg-white ma-1" v-for="subCategory, index in subCategoryList" :key="subCategory.id"
                  style="cursor: pointer">
                  <div @click="categoryPage(subCategory.category_id, subCategory.id)" class="ma-1">
                    <div class="product-img-1 rounded-lg mobile-category-div" v-if="parseFloat(index + 1) % 2 == 1">
                      <v-img height="60" width="60" class="mx-auto" :src="subCategory.image"></v-img>
                      <p class="mobile-category-text text-wrap">{{ subCategory.name }}</p>
                    </div>
                    <div class="product-img-2 rounded-lg mobile-category-div" v-else-if="parseFloat(index + 1) % 3 == 1">
                      <v-img height="60" width="60" class="mx-auto" :src="subCategory.image"></v-img>
                      <p class="mobile-category-text text-wrap">{{ subCategory.name }}</p>
                    </div>
                    <div class="product-img-3  rounded-lg mobile-category-div" v-else-if="parseFloat(index + 1) % 4 == 1">
                      <v-img height="60" width="60" class="mx-auto" :src="subCategory.image"></v-img>
                      <p class="mobile-category-text text-wrap">{{ subCategory.name }}</p>
                    </div>
                    <div class="product-img-4 rounded-lg mobile-category-div" v-else-if="parseFloat(index + 1) % 5 == 1">
                      <v-img height="60" width="60" class="mx-auto" :src="subCategory.image"></v-img>
                      <p class="mobile-category-text text-wrap">{{ subCategory.name }}</p>
                    </div>
                    <div class="product-img-5 rounded-lg mobile-category-div" v-else>
                      <v-img height="60" width="60" class="mx-auto" :src="subCategory.image"></v-img>
                      <p class="mobile-category-text text-wrap">{{ subCategory.name }}</p>
                    </div>
                  </div>
                </v-sheet>
              </v-sheet>
            </div>
          </v-col>
        </v-row>
      </v-container>
      <!--category End-->


      <!--branchstore-->
      <v-row dense no-gutters class="pa-4 bg-secondary">
        <v-col cols="12" sm="12" md="12">
          <div class="mobile-title mt-1  mb-4 text-left">
            Our Brand Stores
          </div>
        </v-col>
        <v-col cols="12" sm="12" md="12"  v-if="brandLists.length != '0'">
          <!--<div class="brand-line"></div>-->
          <div class="d-flex justify-center mb-10">
            <v-sheet class="mx-auto bg-secondary" elevation="0" min-width="300" height="100">
              <v-slide-group>
                <v-slide-group-item v-for="brand in brandLists" :key="brand.id">
                  <v-card width="200" height="125" class="pa-6 rounded-lg justify-center" elevation="0" color="#fff"
                    @click="brandPage(brand.slug)">
                    <v-img class="mx-auto" :src="brand.logo"></v-img>
                  </v-card>
                  <!-- <v-divider vertical></v-divider> -->
                </v-slide-group-item>
              </v-slide-group>
            </v-sheet>
          </div>
        </v-col>
      </v-row>
      <!--branchstore-->

    </div>

    <!--Mobile View End-->


    <AppFooter />
  </div>
</template>
<style scoped>
.web-title {
  font-size: 42px;
  font-weight: bold;
}

.web-text {
  font-size: 16px;
  font-weight: 500;
  line-height: 1.2rem !important;
}

.category-text {
  font-size: 18px;
  font-weight: 500;
}

.best-mobile-chip-text {
  font-size: 11px !important;
}

.mobile-text {
  font-size: 10px !important;
}

.mobile-product-title {
  font-size: 15px !important;
  line-height: 1.2rem;
}

.mobile-title {
  font-size: 18px;
  font-weight: 800;
}

.mobile-category-text {
  font-size: 10px;
}

.product-img-1 {
  background-color: #F6E6E6 !important;
}

.product-img-2 {
  background-color: #E9F3F2 !important;
}

.product-img-3 {
  background-color: #F9F0E9 !important;
}

.product-img-4 {
  background-color: #EBEFF8 !important;
}

.product-img-5 {
  background-color: #F9F7E9 !important;
}

.mobile-category-div {
  width: 95px;
  height: 100px;
}

.organic-card {
  border-radius: 0px 25px 0px 0px;
}

.v-carousel .v-window-item {
  cursor: pointer;
}

.mobile-margin-top {
  margin-top: -20px;
}

.product-web-textbox{
    width: 54px;
    background: #c3bebe7d;
    border-radius: 15px;
    text-align: center;
    font-size: 14px;
}

.product-mobile-textbox{
    width: 54px;
    background: #c3bebe7d;
    border-radius: 15px;
    text-align: center;
    font-size: 13px;
}

.product-mobile-buttonplus{
    margin: 0 !important;
}
</style>
<script>
// @ is an alias to /src

import TopBar from '@/components/Bar.vue'
import AppFooter from '@/components/Footer.vue'

import router from "../router";
import { mapActions, mapGetters } from "vuex";

//images
import logoImage from "../assets/logo.png"
import sigmabanner1 from "../assets/sigmabanner1.jpg"
import group1 from "../assets/group-1.png"
import group2 from "../assets/group-2.png"
import group3 from "../assets/group-3.png"
import group4 from "../assets/group-4.png"
import group5 from "../assets/group-5.png"

export default {
  name: 'HomeView',
  data: () => ({
    logoImage: logoImage,
    sigmabanner1: sigmabanner1,
    group1: group1,
    group2: group2,
    group3: group3,
    group4: group4,
    group5: group5,
  }),
  components: {
    TopBar,
    AppFooter,
  },
  created() {
    this.getBanners();
    this.getSubCategory('');
    this.getHighlighProduct();
    this.getlocationDetails();
    this.getBrandList();
  },
  computed: {
    ...mapGetters([
      "subCategoryList",
      "highlightProductList",
      "bannerList",
      "locationDetails",
      "brandLists",
    ]),
  },
  methods: {
    ...mapActions([
      "getSubCategory",
      "getHighlighProduct",
      "getBanners",
      "addTocart",
      "getlocationDetails",
      "getBrandList",
    ]),
    productUnitSelect(product, unit) {
      //console.log(unit);
      product.unitSelected = unit.unit_id;
      product.priceSelected = unit.unit_price;
      product.unitValueSelected = unit.unit_value;
      product.qty = unit.unit_qty;
      product.proqty = unit.unit_qty;
      product.max_order_qty = unit.max_order_qty;
      //console.log(product);
    },
    categoryPage(categoryId, subCategoryId) {
      router.push("/category/" + categoryId + "/" + subCategoryId);
    },
    productAdd(product) {
      product.qty = 1;
      //console.log(product);
      product.proqty = product.qty
      this.addTocart(product);
    },
    // increment(product) {
    //   //console.log(product);
    //   product.qty = product.qty === product.max_order_qty ? product.max_order_qty : product.qty + 1;
    //   product.unit.filter(function (unit) {
    //     return unit.unit_id === product.unitSelected;
    //   }).map(function (unit) {
    //     return unit.unit_qty = product.qty;
    //   })
    //   //console.log(product.unit);
    //   this.addTocart(product);
    // },
    // decrement(product) {
    //   product.qty = product.qty === 0 ? 0 : product.qty - 1;
    //   //qty update for unit
    //   product.unit.filter(function (unit) {
    //     return unit.unit_id === product.unitSelected;
    //   }).map(function (unit) {
    //     return unit.unit_qty = product.qty;
    //   })
    //   this.addTocart(product);
    // },
    increment(product) {

      if (product.qty < product.max_order_qty) {
        product.qty = product.qty === product.max_order_qty ? product.max_order_qty : product.qty + 1;
        product.unit.filter(function (unit) {
          return unit.unit_id === product.unitSelected;
        }).map(function (unit) {
          return unit.unit_qty = product.qty;
        })
        product.proqty = product.qty
        this.addTocart(product);
      }
      else {
        product.qty = product.max_order_qty;
        product.unit.filter(function (unit) {
          return unit.unit_id === product.unitSelected;
        }).map(function (unit) {
          return unit.unit_qty = product.qty;
        })
        product.proqty = product.qty
        this.addTocart(product);
        this.stocksnackbartext = product.name + ' reached maximum order qty';
        this.stocksnackbar = true;
      }

    },
    decrement(product) {
      if (product.qty <= product.max_order_qty) {
        console.log('1');
        product.qty = product.qty === 0 ? 0 : product.qty - 1;
        //qty update for unit
        product.unit.filter(function (unit) {
          return unit.unit_id === product.unitSelected;
        }).map(function (unit) {
          return unit.unit_qty = product.qty;
        })
        product.proqty = product.qty
        this.addTocart(product);
      }
      else {

        product.qty = product.max_order_qty;
        product.unit.filter(function (unit) {
          return unit.unit_id === product.unitSelected;
        }).map(function (unit) {
          return unit.unit_qty = product.qty;
        })
        product.proqty = product.qty
        this.addTocart(product);
        // console.log('2');
      }
    },

    productqty(product)
    {
        if(product.proqty != '' && product.proqty != null)
        {
            if (product.proqty <= product.max_order_qty) {
                product.qty = product.proqty
            } else {
                product.proqty = product.max_order_qty;
                product.qty = product.max_order_qty;
                this.stocksnackbartext = product.name + ' reached maximum order qty';
                this.stocksnackbar = true;
            }

            product.unit.filter(function (unit) {
                return unit.unit_id === product.unitSelected;
            }).map(function (unit) {
                return unit.unit_qty = product.qty;
            })

            this.addTocart(product);
        } else {
            if(product.proqty == '0')
            {
                product.qty = product.proqty
                product.unit.filter(function (unit) {
                    return unit.unit_id === product.unitSelected;
                }).map(function (unit) {
                    return unit.unit_qty = product.qty;
                })

                this.addTocart(product);
            }
        }
    },
    brandPage(brandSlug) {
      router.push("/brand/" + brandSlug);
    },
    bannerUrl(banner) {
      //console.log(banner);
      window.open(banner.link, '_self', 'noreferrer');
    }
  },
}
</script>

<style>

  .mobile-category-text{
    padding: 0px 3px 0px 3px;
  }

</style>
